import { render, staticRenderFns } from "./SettleAboard.vue?vue&type=template&id=49f4e03f&scoped=true&"
import script from "./SettleAboard.vue?vue&type=script&lang=js&"
export * from "./SettleAboard.vue?vue&type=script&lang=js&"
import style0 from "./SettleAboard.vue?vue&type=style&index=0&id=49f4e03f&prod&lang=less&scoped=true&"
import style1 from "./SettleAboard.vue?vue&type=style&index=1&id=49f4e03f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f4e03f",
  null
  
)

export default component.exports